<div class="filter-radio-group">
  <!-- <input type="radio" [name]="name" id="or" /> -->
  <input type="radio" [name]="name" id="and" />
  <!-- <input type="radio" [name]="name" id="not" /> -->
</div>
